import { IPlatformClient } from "../interfaces/platformClient";
import { ApiClient, ServiceResponse } from "../../common";
import { PlatformSettings } from "../../settings/platformSettings";
import { AuthClient, IAuthClient } from "../../auth";
import { FileClient, IFilesClient } from "../../files";
import { CommsClient, ICommsClient } from "../../comms";
import { ILookupsClient, LookupsClient } from "../../lookups";
import { EventsClient, IEventsClient } from "../../events";
import { IRegistryClient, RegistryClient } from "../../registry";
import { IFormsClient, FormsClient } from "../../forms";

export default class PlatformClient extends ApiClient implements IPlatformClient {
    platformSettings: PlatformSettings;
    auth: IAuthClient;
    files: IFilesClient;
    registry: IRegistryClient;
    comms: ICommsClient;
    lookups: ILookupsClient;
    events: IEventsClient;
    forms: IFormsClient;

    constructor(platformSettings: PlatformSettings) {
        super();
        this.platformSettings = platformSettings;
        this.auth = new AuthClient(platformSettings);
        this.files = new FileClient(platformSettings);
        this.registry = new RegistryClient(platformSettings);
        this.comms = new CommsClient(platformSettings);
        this.lookups = new LookupsClient(platformSettings);
        this.events = new EventsClient(platformSettings);
        this.forms = new FormsClient(platformSettings);
    }

    public async GetAuthScopes(accessToken: string): Promise<ServiceResponse<Array<string>>> {
        return await super.Get<Array<string>>(this.platformSettings.apiUrl, `auth-scopes`, accessToken);
    }

    public async GetDependencies(accessToken: string): Promise<ServiceResponse<Array<object>>> {
        return await super.Get<Array<object>>(this.platformSettings.apiUrl, `dependencies`, accessToken);
    }
}

export { PlatformClient }